/**
 * Chrome icons copied as is from the NextAdmin template (commit e0b72a9aa69e):
 * `utils/icon.tsx`, `components/common/sidebar/icon.tsx`, `components/common/header/icons.tsx`.
 * Navigation entry icons are not here: they come from the module manifests through `modules/icons.ts`.
 */
export type IconProps = React.SVGProps<SVGSVGElement>;

export const AltArrowUpIcon = (props: IconProps) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
      <path
        d="M13.875 11.25L9 6.75L4.125 11.25"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AltArrowDownIcon = (props: IconProps) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M15.4166 7.5L9.99992 12.5L4.58326 7.5"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MenuDotsIcon = (props: IconProps) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        d="M5.83333 10.0002C5.83333 10.9206 5.08714 11.6668 4.16667 11.6668C3.24619 11.6668 2.5 10.9206 2.5 10.0002C2.5 9.07969 3.24619 8.3335 4.16667 8.3335C5.08714 8.3335 5.83333 9.07969 5.83333 10.0002Z"
        fill="currentColor"
      />
      <path
        d="M11.6667 10.0002C11.6667 10.9206 10.9205 11.6668 10 11.6668C9.07953 11.6668 8.33333 10.9206 8.33333 10.0002C8.33333 9.07969 9.07953 8.3335 10 8.3335C10.9205 8.3335 11.6667 9.07969 11.6667 10.0002Z"
        fill="currentColor"
      />
      <path
        d="M17.5 10.0002C17.5 10.9206 16.7538 11.6668 15.8333 11.6668C14.9129 11.6668 14.1667 10.9206 14.1667 10.0002C14.1667 9.07969 14.9129 8.3335 15.8333 8.3335C16.7538 8.3335 17.5 9.07969 17.5 10.0002Z"
        fill="currentColor"
      />
    </svg>
  );
};

export function SidebarExpandedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
      <path
        d="M1.5 8.25C1.5 5.42157 1.5 4.00736 2.37868 3.12868C3.25736 2.25 4.67157 2.25 7.5 2.25H10.5C13.3284 2.25 14.7426 2.25 15.6213 3.12868C16.5 4.00736 16.5 5.42157 16.5 8.25V9.75C16.5 12.5784 16.5 13.9926 15.6213 14.8713C14.7426 15.75 13.3284 15.75 10.5 15.75H7.5C4.67157 15.75 3.25736 15.75 2.37868 14.8713C1.5 13.9926 1.5 12.5784 1.5 9.75V8.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M4.125 7.5H8.625" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M4.875 10.5H7.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M11.25 15.75L11.25 2.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export function ThreeDots() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={4} viewBox="0 0 18 4" fill="none">
      <path
        d="M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2Z"
        fill="currentColor"
      />
      <path
        d="M11 2C11 3.10457 10.1046 4 9 4C7.89543 4 7 3.10457 7 2C7 0.89543 7.89543 0 9 0C10.1046 0 11 0.89543 11 2Z"
        fill="currentColor"
      />
      <path
        d="M18 2C18 3.10457 17.1046 4 16 4C14.8954 4 14 3.10457 14 2C14 0.89543 14.8954 0 16 0C17.1046 0 18 0.89543 18 2Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

export const SearchIcon = (props: IconProps) => {
  return (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <circle cx="9.58341" cy="9.58317" r="7.91667" stroke="currentColor" strokeWidth="1.5" />
      <path d="M15.4167 15.4165L18.3334 18.3332" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
};

export const BellIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99999 1.0415C6.43315 1.0415 3.54166 3.933 3.54166 7.49984V8.08659C3.54166 8.66736 3.36975 9.23513 3.0476 9.71836L2.09043 11.1541C0.979516 12.8205 1.82761 15.0855 3.75977 15.6125C4.38944 15.7842 5.02444 15.9294 5.66311 16.0482L5.66469 16.0525C6.30552 17.7624 8.01828 18.9582 9.99994 18.9582C11.9816 18.9582 13.6944 17.7624 14.3352 16.0525L14.3368 16.0483C14.9755 15.9295 15.6105 15.7842 16.2402 15.6125C18.1724 15.0855 19.0205 12.8205 17.9096 11.1541L16.9524 9.71836C16.6302 9.23513 16.4583 8.66736 16.4583 8.08659V7.49984C16.4583 3.933 13.5668 1.0415 9.99999 1.0415ZM12.8137 16.2806C10.9445 16.504 9.05533 16.504 7.1862 16.2806C7.77866 17.1319 8.80914 17.7082 9.99994 17.7082C11.1907 17.7082 12.2212 17.1319 12.8137 16.2806ZM4.79166 7.49984C4.79166 4.62335 7.12351 2.2915 9.99999 2.2915C12.8765 2.2915 15.2083 4.62335 15.2083 7.49984V8.08659C15.2083 8.91414 15.4533 9.72317 15.9123 10.4117L16.8695 11.8475C17.5071 12.804 17.0203 14.104 15.9113 14.4065C12.0411 15.462 7.95887 15.462 4.08866 14.4065C2.97964 14.104 2.49285 12.804 3.13049 11.8475L4.08766 10.4117C4.5467 9.72317 4.79166 8.91414 4.79166 8.08659V7.49984Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UserCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
    <circle cx={9} cy="6.75" r="2.25" stroke="currentColor" strokeWidth="1.5" />
    <circle cx={9} cy={9} r="7.5" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M13.477 15C13.3576 12.8314 12.6936 11.25 9.00008 11.25C5.30653 11.25 4.64255 12.8314 4.52319 15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const GearIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
    <circle cx={9} cy={9} r="2.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M10.3241 1.61418C10.0485 1.5 9.69903 1.5 9.00011 1.5C8.3012 1.5 7.95174 1.5 7.67609 1.61418C7.30855 1.76642 7.01653 2.05843 6.86429 2.42597C6.7948 2.59376 6.7676 2.78888 6.75696 3.07349C6.74132 3.49176 6.52681 3.87892 6.16433 4.0882C5.80185 4.29747 5.35931 4.28965 4.98927 4.09407C4.73746 3.96098 4.55488 3.88697 4.37482 3.86326C3.9804 3.81134 3.58151 3.91822 3.26589 4.1604C3.02918 4.34203 2.85445 4.64467 2.505 5.24995C2.15554 5.85522 1.98081 6.15786 1.94187 6.45368C1.88994 6.8481 1.99682 7.24699 2.239 7.56261C2.34954 7.70667 2.5049 7.82777 2.74601 7.97927C3.10047 8.20199 3.32854 8.58139 3.32852 9.00002C3.32849 9.41859 3.10043 9.79795 2.74601 10.0206C2.50486 10.1722 2.34948 10.2933 2.23893 10.4373C1.99675 10.753 1.88987 11.1518 1.94179 11.5463C1.98074 11.8421 2.15547 12.1447 2.50492 12.75C2.85438 13.3553 3.02911 13.6579 3.26582 13.8395C3.58143 14.0817 3.98033 14.1886 4.37475 14.1367C4.55479 14.113 4.73736 14.039 4.98915 13.9059C5.35923 13.7103 5.80179 13.7025 6.1643 13.9118C6.5268 14.1211 6.74131 14.5083 6.75696 14.9265C6.7676 15.2111 6.7948 15.4063 6.86429 15.574C7.01653 15.9416 7.30855 16.2336 7.67609 16.3858C7.95174 16.5 8.3012 16.5 9.00011 16.5C9.69903 16.5 10.0485 16.5 10.3241 16.3858C10.6917 16.2336 10.9837 15.9416 11.1359 15.574C11.2054 15.4062 11.2326 15.2111 11.2433 14.9265C11.2589 14.5082 11.4734 14.1211 11.8359 13.9118C12.1984 13.7025 12.6409 13.7103 13.011 13.9059C13.2628 14.0389 13.4454 14.1129 13.6254 14.1366C14.0198 14.1886 14.4187 14.0817 14.7343 13.8395C14.971 13.6579 15.1458 13.3552 15.4952 12.7499C15.8447 12.1447 16.0194 11.842 16.0584 11.5462C16.1103 11.1518 16.0034 10.7529 15.7612 10.4373C15.6507 10.2932 15.4953 10.1721 15.2542 10.0206C14.8997 9.7979 14.6717 9.41852 14.6717 8.99993C14.6717 8.58139 14.8998 8.20206 15.2542 7.97939C15.4954 7.82786 15.6507 7.70674 15.7613 7.56266C16.0035 7.24705 16.1104 6.84815 16.0584 6.45373C16.0195 6.15791 15.8448 5.85528 15.4953 5.25C15.1458 4.64472 14.9711 4.34209 14.7344 4.16045C14.4188 3.91827 14.0199 3.81139 13.6255 3.86331C13.4454 3.88702 13.2629 3.96102 13.0111 4.0941C12.641 4.28969 12.1984 4.29751 11.8359 4.08822C11.4734 3.87893 11.2589 3.49175 11.2433 3.07345C11.2326 2.78886 11.2054 2.59375 11.1359 2.42597C10.9837 2.05843 10.6917 1.76642 10.3241 1.61418Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const BillingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
    <path d="M4.5 6H7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M15.625 6.75H13.6731C12.3348 6.75 11.25 7.75736 11.25 9C11.25 10.2426 12.3348 11.25 13.6731 11.25H15.625C15.6875 11.25 15.7187 11.25 15.7451 11.2484C16.1496 11.2238 16.4718 10.9246 16.4983 10.5491C16.5 10.5246 16.5 10.4955 16.5 10.4375V7.5625C16.5 7.50447 16.5 7.47545 16.4983 7.45095C16.4718 7.07538 16.1496 6.77622 15.7451 6.75161C15.7187 6.75 15.6875 6.75 15.625 6.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <circle cx="13.5" cy={9} r="0.75" fill="currentColor" />
    <path
      d="M15.7238 6.75C15.6655 5.34577 15.4775 4.48481 14.8713 3.87868C13.9926 3 12.5784 3 9.75 3L7.5 3C4.67157 3 3.25736 3 2.37868 3.87868C1.5 4.75736 1.5 6.17157 1.5 9C1.5 11.8284 1.5 13.2426 2.37868 14.1213C3.25736 15 4.67157 15 7.5 15H9.75C12.5784 15 13.9926 15 14.8713 14.1213C15.4775 13.5152 15.6655 12.6542 15.7238 11.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18" fill="none">
    <path
      d="M6.75146 5.25C6.76055 3.61873 6.83288 2.7353 7.40917 2.15901C8.06818 1.5 9.12884 1.5 11.2502 1.5L12.0002 1.5C14.1215 1.5 15.1821 1.5 15.8412 2.15901C16.5002 2.81802 16.5002 3.87868 16.5002 6L16.5002 12C16.5002 14.1213 16.5002 15.182 15.8412 15.841C15.1821 16.5 14.1215 16.5 12.0002 16.5H11.2502C9.12884 16.5 8.06818 16.5 7.40917 15.841C6.83288 15.2647 6.76055 14.3813 6.75146 12.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.25 9L1.5 9M4.125 11.25L1.5 9L4.125 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SunIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18124 2.33448C5.30901 2.74335 2.29175 6.01923 2.29175 9.99984C2.29175 14.257 5.74289 17.7082 10.0001 17.7082C13.9807 17.7082 17.2566 14.6909 17.6654 10.8187C16.5598 12.2222 14.8439 13.1248 12.9167 13.1248C9.58003 13.1248 6.87508 10.4199 6.87508 7.08317C6.87508 5.15599 7.77771 3.44009 9.18124 2.33448ZM1.04175 9.99984C1.04175 5.05229 5.05253 1.0415 10.0001 1.0415C10.5973 1.0415 10.8962 1.51755 10.9475 1.89673C10.9967 2.26148 10.8619 2.72538 10.4426 2.97873C9.05229 3.81884 8.12508 5.34302 8.12508 7.08317C8.12508 9.72954 10.2704 11.8748 12.9167 11.8748C14.6569 11.8748 16.1811 10.9476 17.0212 9.55731C17.2745 9.13804 17.7384 9.00321 18.1032 9.05247C18.4824 9.10368 18.9584 9.40265 18.9584 9.99984C18.9584 14.9474 14.9476 18.9582 10.0001 18.9582C5.05253 18.9582 1.04175 14.9474 1.04175 9.99984Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MoonIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.18112 2.33473C5.30889 2.74359 2.29163 6.01948 2.29163 10.0001C2.29163 14.2573 5.74276 17.7084 9.99996 17.7084C13.9806 17.7084 17.2564 14.6912 17.6653 10.8189C16.5597 12.2225 14.8438 13.1251 12.9166 13.1251C9.57991 13.1251 6.87496 10.4201 6.87496 7.08341C6.87496 5.15623 7.77759 3.44033 9.18112 2.33473ZM1.04163 10.0001C1.04163 5.05253 5.05241 1.04175 9.99996 1.04175C10.5972 1.04175 10.8961 1.5178 10.9473 1.89697C10.9966 2.26173 10.8618 2.72563 10.4425 2.97897C9.05217 3.81909 8.12496 5.34327 8.12496 7.08341C8.12496 9.72978 10.2703 11.8751 12.9166 11.8751C14.6568 11.8751 16.181 10.9479 17.0211 9.55755C17.2744 9.13828 17.7383 9.00345 18.1031 9.05271C18.4822 9.10392 18.9583 9.40289 18.9583 10.0001C18.9583 14.9476 14.9475 18.9584 9.99996 18.9584C5.05241 18.9584 1.04163 14.9476 1.04163 10.0001Z"
        fill="currentColor"
        fillOpacity="0.9"
      />
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
};
